// extracted by mini-css-extract-plugin
export default {"container":"ResponseSuccess_container__KksDv","text":"ResponseSuccess_text__any10","icon":"ResponseSuccess_icon__-xmzu"};